<template>
  <div
    :class="['hjx-header', headerWrapClass, bottomLine ? 'hjx-1px-b' : '']"
    v-if="show"
  >
    <div class="header-block" v-if="isInApp" :style="{ height: hStyle }"></div>
    <div class="header-box">
      <div @click="onleftBtnClick" class="isleft">
        <div v-if="leftBtnShow">
          <i class="hjx-back"></i>
        </div>
      </div>
      <div v-if="title" class="header-title">{{ title }}</div>
      <div @click="onrightBtnClick" class="isright">
        <div v-if="rightBtnShow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import app from '@/common/app';
export default {
  name: 'hjx-header',
  data() {
    return {
      leftBtnClick: false,
      rightBtnClick: false,
    };
  },
  inject: ['barStyle'],
  props: {
    headerWrapClass: {
      type: String,
    },
    isInApp: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      require: true,
    },
    leftBtnShow: {
      type: Boolean,
      default: true,
    },
    rightBtnShow: {
      type: Boolean,
      default: false,
    },
    leftBtnClickFn: {
      default: '',
    },
    rightBtnClickFn: {
      default: '',
    },
    bottomLine: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hStyle() {
      return this.barStyle.height;
    },
    show() {
      return this.$route.query.showNav !== '0';
    },
  },
  components: {},
  created() {},
  methods: {
    onleftBtnClick() {
      if (!this.leftBtnShow || this.leftBtnClick) return;
      this.leftBtnClick = true;
      Promise.resolve(
        (() => {
          if (this.leftBtnClickFn) {
            return this.leftBtnClickFn(this);
          }
          return this.goBack();
        })()
      ).finally(() => {
        this.leftBtnClick = false;
      });
    },
    goBack() {
      try {
        app.backByApp();
        return;
      } catch (error) {
        if (error.message) {
          this.$toast(error.message);
        }
        return;
      }
    },
    onrightBtnClick() {
      if (!this.rightBtnShow || this.rightBtnClick) return;
      this.rightBtnClick = true;
      Promise.resolve(() => {
        if (this.rightBtnClickFn) {
          return this.rightBtnClickFn(this);
        }
      }).finally(() => {
        this.rightBtnClickleftBtnClick = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hjx-header {
  background: #fff;
}
.header-block {
  height: 20px;
  width: 100vw;
}
.header-box {
  height: 44px;
  color: inherit;
  font-size: 16px;
  font-weight: bold;
  background-color: inherit;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  padding: 0 0.2rem;
  position: relative;
  text-align: center;
  white-space: nowrap;
  line-height: 1;
  .isleft {
    text-align: left;
    flex: 0.5;
  }
  .isright {
    text-align: right;
    flex: 0.5;
  }
  .header-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: inherit;
    font-weight: 400;
    line-height: 1.4;
    flex: 1;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2c2c2c;
    font-size: 18px;
  }
}
.hjx-back {
  display: block;
  height: 20px;
  width: 20px;
}
</style>

